import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import {
  acceptRejectDocument,
  fileUpload,
  getDocumentFile,
  postDocumentFile,
  updateDocumentFile,
} from "../../../store/actions";
import Loading from "../../../Common/extra/loading";
import ImagePreview from "../../../Common/extra/ImagePreview";
import FileUploader from "./FilePreview";

const EditAddressIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId, docId } = useParams();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [data, setData] = useState({
    image_url: [],
    fileName: "",
    status: "submitted",
  });
  const [errors, setError] = useState({
    image_url: "",
  });
  const [loading, setLoading] = useState(false);
  const DocumentData = useSelector((s) => s?.Customers?.getDocumentFile?.data);

  useEffect(() => {
    if (DocumentData) {
      setData((pre) => ({
        ...pre,
        image_url: DocumentData?.image_url,
      }));
    }
  }, [DocumentData]);

  useEffect(() => {
    if (data.image_url) {
      setData((pre) => ({
        ...pre,
        fileName: data.image_url.map((item) => item.split("/")[3]),
      }));
    }
  }, [data.image_url]);

  // useEffect(() => {
  //   if (docId) {
  //     dispatch(getDocumentFile({ docId: docId, user_id: userId }));
  //   }
  // }, [docId]);

  const handleFileUpload = () => {
    let formData = new FormData();

    for (let index = 0; index < uploadedFiles.length; index++) {
      formData.append("project_image[]", uploadedFiles[index]);
    }
    const callback = (url) => {
      const postCallBack = (res) => {
        if (res.status == 200) {
          toast.success("Success!");
          setLoading(false);
          navigate(`/customers/profile/${userId}`);
        }
      };
      if (url) {
        dispatch(
          postDocumentFile(
            {
              user_id: userId,
              document_id: docId,
              image_url: url.files,
              status: data.status,
            },
            postCallBack
          )
        );
      }
    };
    setLoading(true);
    dispatch(fileUpload(formData, null, callback));
  };

  const handleStatusSubmit = (e, status) => {
    e.preventDefault();
    const callBack = (res) => {
      if (res.status == 200) {
        toast.success("Success!");
        navigate(`/customers/profile/${userId}`);
      }
    };
    dispatch(
      acceptRejectDocument(
        {
          user_id: userId,
          document_id: docId,
          status: status,
        },
        callBack
      )
    );
  };

  return (
    <>
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="">Upload Document</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row className="">
                    {!loading ? (
                      <>
                        <Col md={12}>
                          <FileUploader
                            setUploadedFiles={setUploadedFiles}
                            uploadedFiles={uploadedFiles}
                          />
                          {/*   <input
                              type="file"
                              class="position-absolute"
                              name="image_url"
                              title={
                                data.fileName != "Drag/Drop or Upload File" &&
                                data.fileName
                              }
                              onChange={(e) => handleFileUpload(e)}
                            />
                            <div class="inner text-center">
                              <div class="icn my-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                >
                                  <path
                                    d="M13.2375 16.7625C13.75 17.25 13.75 18.05 13.2375 18.5375C12.75 19.025 11.95 19.025 11.4625 18.5375C10.2917 17.365 9.63412 15.7757 9.63412 14.1188C9.63412 12.4618 10.2917 10.8725 11.4625 9.7L15.8875 5.275C17.06 4.10422 18.6493 3.44664 20.3062 3.44664C21.9632 3.44664 23.5525 4.10422 24.725 5.275C25.8958 6.44754 26.5534 8.03678 26.5534 9.69375C26.5534 11.3507 25.8958 12.94 24.725 14.1125L22.8625 15.975C22.875 14.95 22.7125 13.925 22.3625 12.95L22.95 12.35C23.3004 12.0034 23.5786 11.5907 23.7685 11.1358C23.9583 10.6809 24.0561 10.1929 24.0561 9.7C24.0561 9.2071 23.9583 8.71908 23.7685 8.26421C23.5786 7.80934 23.3004 7.39664 22.95 7.05C22.6033 6.69958 22.1906 6.42139 21.7358 6.23152C21.2809 6.04166 20.7929 5.9439 20.3 5.9439C19.8071 5.9439 19.3191 6.04166 18.8642 6.23152C18.4093 6.42139 17.9966 6.69958 17.65 7.05L13.2375 11.4625C12.8871 11.8091 12.6089 12.2218 12.419 12.6767C12.2292 13.1316 12.1314 13.6196 12.1314 14.1125C12.1314 14.6054 12.2292 15.0934 12.419 15.5483C12.6089 16.0032 12.8871 16.4159 13.2375 16.7625M16.7625 11.4625C17.25 10.975 18.05 10.975 18.5375 11.4625C19.7083 12.635 20.3659 14.2243 20.3659 15.8812C20.3659 17.5382 19.7083 19.1275 18.5375 20.3L14.1125 24.725C12.94 25.8958 11.3507 26.5534 9.69374 26.5534C8.03677 26.5534 6.44752 25.8958 5.27499 24.725C4.10421 23.5525 3.44662 21.9632 3.44662 20.3063C3.44662 18.6493 4.10421 17.06 5.27499 15.8875L7.13749 14.025C7.12499 15.05 7.28749 16.075 7.63749 17.0625L7.04999 17.65C6.69957 17.9966 6.42137 18.4093 6.23151 18.8642C6.04165 19.3191 5.94389 19.8071 5.94389 20.3C5.94389 20.7929 6.04165 21.2809 6.23151 21.7358C6.42137 22.1907 6.69957 22.6034 7.04999 22.95C7.39663 23.3004 7.80933 23.5786 8.2642 23.7685C8.71907 23.9583 9.20708 24.0561 9.69999 24.0561C10.1929 24.0561 10.6809 23.9583 11.1358 23.7685C11.5906 23.5786 12.0033 23.3004 12.35 22.95L16.7625 18.5375C17.1129 18.1909 17.3911 17.7782 17.581 17.3233C17.7708 16.8684 17.8686 16.3804 17.8686 15.8875C17.8686 15.3946 17.7708 14.9066 17.581 14.4517C17.3911 13.9968 17.1129 13.5841 16.7625 13.2375C16.6411 13.1237 16.5443 12.9863 16.4782 12.8336C16.412 12.681 16.3779 12.5164 16.3779 12.35C16.3779 12.1836 16.412 12.019 16.4782 11.8664C16.5443 11.7137 16.6411 11.5763 16.7625 11.4625V11.4625Z"
                                    fill="#515462"
                                  ></path>
                                </svg>
                                <p class="text-capitalize m-0">
                                  {data.fileName}
                                </p>
                              </div>
                            </div>
                          </div> */}
                        </Col>
                      </>
                    ) : (
                      <div className="upload-loading">
                        <Loading />
                      </div>
                    )}
                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex align-items-center">
                        <Button
                          onClick={handleFileUpload}
                          disabled={uploadedFiles.length > 0 ? false : true}
                          className="d-flex align-items-center justify-content-center me-2"
                        >
                          Submit
                        </Button>
                        <Link
                          to={`/customers/profile/${userId}`}
                          className="d-flex py-1 btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default EditAddressIndex;
